import * as React from 'react';
import { ReactElement } from 'react';

const IconIndeterminate = ({ ...props }): ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="12" cy="12" r="10" stroke="#10284B" strokeWidth="2" />
    </svg>
  );
};

export default IconIndeterminate;
